export default {"src":"/_next/static/media/ArrowRightLight.c2cbd12b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};